<app-table-form-container
	[loading]="loading()"
	modelName="Lesson"
	[showForm]="isFormShowing()"
	(onShowForm)="onShowForm()"
	(onHideForm)="onHideForm()"
>
	<ng-template #tableTemplate>
		<app-cms-table
			[tableKey]="'lesson-list'"
			[loading]="loading()"
			[rows]="lessons()"
			[columns]="columns()"
			[selectedUuid]="editLesson()?.uuid"
			[uuidsInProgress]="uuidsInProgress()"
			(onSelect)="select($event)"
			(onCopy)="copy($event)"
			(onCopyBulk)="copyBulk($event)"
			(onEdit)="edit($event)"
			(onDelete)="delete$($event)"
			(onMoveUp)="moveUp$($event)"
			(onMoveDown)="moveDown$($event)"
		>
			<!-- Header templates (defines order/keys) -->
			<ng-template appHeaderColumn="lessonName">Lesson</ng-template>

			<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
			<ng-template appRowColumn="lessonName" let-row>
				<div class="name-column clickable">
					{{ row.active_text.name }}
				</div>
			</ng-template>
		</app-cms-table>
	</ng-template>

	<ng-template #formTemplate>
		<nz-card>
			<app-language-selector (onChange)="onEditLanguageChange($event)"></app-language-selector>
			<app-lesson-form
				[lesson]="editLesson()"
				[editLanguage]="editLanguage()"
				(onSubmit)="onLessonFormSubmit$($event)"
			></app-lesson-form>
		</nz-card>
	</ng-template>
</app-table-form-container>
